{
  "appTitle": "BACK OFFICE",
  "greetings": [
    "Hej! Miło cię znowu widzieć!",
    "Witaj z powrotem! Gotowy do działania?",
    "Dobrze cię mieć z powrotem!",
    "Cześć! Do roboty.",
    "Znowu tu jesteś? No to zaczynamy!",
    "Miło cię widzieć. Zaczynajmy."
  ],
  "email": "Email",
  "continue": "Kontynuuj",
  "password": "Hasło",
  "sign-in": "Zaloguj się",
  "back": "Użyj innego adresu e-mail",
  "sso-redirecting": "Przekierowywanie do SSO...",
  "or": "lub",
  "passkey": {
    "signIn": "Zaloguj się kluczem dostępu",
    "error": "Logowanie kluczem dostępu nie powiodło się. Spróbuj ponownie lub użyj hasła.",
    "unknownCredential": "Ten klucz dostępu nie jest rozpoznawany. Zaloguj się za pomocą hasła."
  },
  "mfa": {
    "label": "Kod uwierzytelniający",
    "hint": "Wprowadź 6-cyfrowy kod z aplikacji uwierzytelniającej.",
    "verify": "Weryfikuj",
    "invalidCode": "Nieprawidłowy kod — spróbuj ponownie."
  },
  "changePassword": {
    "description": "Zanim przejdziesz dalej, musisz zaktualizować hasło.",
    "current": "Obecne hasło",
    "new": "Nowe hasło",
    "confirm": "Potwierdź nowe hasło",
    "submit": "Zaktualizuj hasło",
    "mismatch": "Nowe hasła nie są takie same.",
    "wrongCurrent": "Obecne hasło jest nieprawidłowe.",
    "error": "Nie udało się zaktualizować hasła. Spróbuj ponownie."
  },
  "errors": {
    "invalidCredentials": "Nie można się zalogować, sprawdź dane logowania i spróbuj ponownie",
    "unauthorized": "Nie można się zalogować, spróbuj ponownie",
    "accountLocked": "Konto jest zablokowane, spróbuj ponownie później",
    "accessNotGranted": "Brak dostępu do Back Office",
    "ssoRequired": "To konto korzysta z logowania jednokrotnego (SSO). Zaloguj się przez SSO."
  }
}
